import { render, staticRenderFns } from "./CustomerListTable.vue?vue&type=template&id=4cc718b0"
import script from "./CustomerListTable.vue?vue&type=script&lang=js"
export * from "./CustomerListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports